import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../../_metronic/_partials/controls";
import { SelectObjectsField } from "../../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField";
import { SelectStatus } from "../../../customComponents/SelectStatus";


export const initObject = {
  id: undefined,
  questionId: 0,
  questionTitle: "",
  maxAnswer: 0,
  questionOrder: 0,
  formTypeId: 0,
  formTypeTitle: "",
  isDeleted: false
};

export const columns = [
  {
    dataField: "formTypeTitle",
    text: "پرسشنامه",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "questionTitle",
    text: "پرسش",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "questionCode",
    text: "کد پرسش",
    sort: true,
    sortCaret: sortCaret,
  },

  {
    dataField: "enteredAnswer",
    text: "پاسخ ثبت شده",
    sort: true,
    sortCaret: sortCaret,
  },
  // {
  //     dataField: "maxAnswer",
  //     text: "حداکثر پاسخ",
  //     sort: true,
  //     sortCaret: sortCaret,
  // },
  // {
  //     dataField: "answeredType",
  //     text: "نوع پاسخ",
  //     sort: true,
  //     sortCaret: sortCaret,
  // },
  // {
  //     dataField: "allowedAnswer",
  //     text: " پاسخ مجاز",
  //     sort: true,
  //     sortCaret: sortCaret,
  // },
  // {
  //     dataField: "allowed",
  //     text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
  //     // text: "وضعیت",
  //     sort: true,
  //     sortCaret: sortCaret,
  //     formatter: columnFormatters.AllowedColumnFormatter,
  // },

];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "title",
        type: "text",
        component: Input,
        placeholder: "عنوان",
        label: "عنوان",
        rowIdx: 1,
        class: "col-lg-4"
      },
      {
        name: "auditPeriodId",
        type: "text",
        component: (props) => <SelectObjectsField api="api/FormQuestion"
          reduxState="forms"
          sname="auditPeriodId"
          label="پرسشنامه " {...props} />,
        placeholder: "پرسشنامه ",
        label: "پرسشنامه ",
        rowIdx: 2,
        class: "col-lg-4"
      },
      {
        name: "buildingId",
        type: "text",
        component: (props) => <SelectObjectsField api="api/building"
          reduxState="buildings"
          sname="buildingId"
          label="بلوک" {...props} />,
        placeholder: "بلوک",
        label: "بلوک",
        rowIdx: 3,
        class: "col-lg-4"
      },
    ]
  },
  {
    row: 2,
    list: [
      {
        name: "auditListId",
        type: "text",
        component: (props) => <SelectObjectsField api="api/auditList"
          reduxState="auditList"
          sname="auditListId"
          label="دوره ارزیابی" {...props} />,
        placeholder: "دوره ارزیابی",
        label: "دوره ارزیابی",
        rowIdx: 4,
        class: "col-lg-4"
      },

    ]
  },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];



export const filterFields = [
  {
    name: "formTypeId",
    lable: "پرسشنامه",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/formType"
        reduxState="formTypes"
        sname="formTypeId"
        {...props} />
  },
  {
    name: "auditPeriodId",
    lable: "دوره ارزیابی",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/AuditPeriod"
        reduxState="auditPeriods"
        sname="auditPeriodId"
        {...props} />
  },
  {
    name: "placeId",
    lable: "پردیس / مرکز",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/place"
        reduxState="places"
        sname="placeId"
        {...props} />
  },

  {
    name: "buildingId",
    lable: "بلوک",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/building"
        reduxState="buildings"
        sname="buildingId"
        {...props} />
  },
  {
    name: "floorId",
    lable: "طبقه",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/floor"
        reduxState="floors"
        sname="floorId"
        {...props} />
  },

  // {
  //   name: "searchText",
  //   lable: "MODULES.GENERAL.SEARCH",
  //   type: "text",
  //   list: [],
  // },

];

export const filterInitialValues = {
  filter: {
    allowed: "", // values => All=""/Selling=0/Sold=1
    searchText: "",
    placeId: 0,
    auditPeriodId: 0,
    buildingId: 0,
    formTypeId: 0,
    floorId: 0,
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};

export const prepareFilter = (queryParams, values) => {
  const { allowed, searchText, placeId, auditPeriodId, buildingId, formTypeId, floorId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by allowed
  filter.allowed = allowed !== "" ? +allowed : undefined;

  // Filter by auditPeriodId
  filter.placeId = placeId !== "" ? +placeId : 0;
  filter.auditPeriodId = auditPeriodId !== "" ? +auditPeriodId : 0;
  filter.buildingId = buildingId !== "" ? +buildingId : 0;
  filter.floorId = floorId !== "" ? +floorId : 0;
  filter.formTypeId = formTypeId !== "" ? +formTypeId : 0;

  // // Filter by all fields
  // filter.title = searchText;
  // if (searchText) {
  //   filter.title = searchText;
  // }
  newQueryParams.filter = filter;

  let whereClause = ""
  // let whereClause = "title.contains(@0)"
  const whereClauseParameters = [];
  // whereClauseParameters.push(searchText)


  var idx = 0;

  if (filter.placeId > 0 && idx === 0) {
    whereClause = `placeId=@${idx}`
    whereClauseParameters.push(filter.placeId)
    idx++;
  }
  else if (filter.placeId > 0 && idx > 0) {
    whereClause = whereClause + ` and placeId=@${idx}`
    whereClauseParameters.push(filter.placeId)
    idx++;
  }

  if (filter.auditPeriodId > 0 && idx === 0) {
    whereClause = `auditPeriodId=@${idx}`
    whereClauseParameters.push(filter.auditPeriodId)
    idx++;
  }
  else if (filter.auditPeriodId > 0 && idx > 0) {
    whereClause = whereClause + ` and auditPeriodId=@${idx}`
    whereClauseParameters.push(filter.auditPeriodId)
    idx++;
  }

  if (filter.buildingId > 0 && idx === 0) {
    whereClause = `buildingId=@${idx}`
    whereClauseParameters.push(filter.buildingId)
    idx++;
  }
  else if (filter.buildingId > 0 && idx > 0) {
    whereClause = whereClause + ` and buildingId=@${idx}`
    whereClauseParameters.push(filter.buildingId)
    idx++;
  }

  if (filter.floorId > 0 && idx === 0) {
    whereClause = `floorId=@${idx}`
    whereClauseParameters.push(filter.floorId)
    idx++;
  }
  else if (filter.floorId > 0 && idx > 0) {
    whereClause = whereClause + ` and floorId=@${idx}`
    whereClauseParameters.push(filter.floorId)
    idx++;
  }

  if (filter.formTypeId > 0 && idx === 0) {
    whereClause = `formTypeId=@${idx}`
    whereClauseParameters.push(filter.formTypeId)
    idx++;
  }
  else if (filter.formTypeId > 0 && idx > 0) {
    whereClause = whereClause + ` and formTypeId=@${idx}`
    whereClauseParameters.push(filter.formTypeId)
    idx++;
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  // title: Yup.string()
  //   .required("پر کردن فیلد الزامی است"),
  // auditPeriodId: Yup.number()
  //   .required("auditPeriodId is required"),
  // psp: Yup.number()
  //   .min(6, "6 is minimum")
  //   .max(18, "18 is maximum"),

});

